import { useState, useEffect, useContext, useRef } from 'react';
import { Modal } from 'bootstrap';
import { CatalogDispatchContext, UxContext } from '../store/CatalogContext';
import parse from 'html-react-parser';

export default function FeeDescriptionModal() {
  const catalogDispatch = useContext(CatalogDispatchContext);
  const ux = useContext(UxContext);

  if (!ux.showFeeDescription) {
    return null;
  }

  const feeModalEl = useRef<HTMLDivElement>(null);

  const [feeModal, setFeeModal] = useState<Modal | null>(null);

  const [fee, setFee] = useState({
    name: '',
    description: '',
  });

  useEffect(() => {
    if (feeModalEl.current) {
      const modalInstance = new Modal(feeModalEl.current);
      setFeeModal(modalInstance);

      feeModalEl.current.addEventListener('hide.bs.modal', () => {
        // trigger to hide the toast notification
        catalogDispatch({
          type: 'UX',
          payload: {
            showFeeDescription: null,
          },
        });
      });
    }
  }, [catalogDispatch]);

  useEffect(() => {
    if (!ux.showFeeDescription && feeModal) {
      feeModal.hide();
    }
    if (ux.showFeeDescription && feeModal) {
      feeModal.show();
    }
  }, [ux.showFeeDescription, feeModal]);

  useEffect(() => {
    if (ux.showFeeDescription) {
      setFee({
        name: ux.showFeeDescription.name,
        description: ux.showFeeDescription.description,
      });
    }
  }, [ux.showFeeDescription]);

  return (
    <div
      className="modal fade text-start lh-16"
      ref={feeModalEl}
      id="fee-description-modal"
      tabIndex={-1}
      aria-hidden="true"
    >
      <div className="fee-modal modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-body p-3 p-md-4">
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            <h3 className="modal-title fw-600 h5 mb-2">{fee.name}</h3>
            <p className="line-break fw-500 mb-0">{parse(fee.description)}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
